import axios from '@/utils/request'
import { useReq } from '@/utils/request/useReq'

const queryHomeUrl = '/activity/newcomer/homepage/query'
const queryHome = async (params) => {
  const { data } = await axios.post(queryHomeUrl, params)
  return data.data
}

const getWoolPartyUserUrl = '/activity/getWoolPartyUser'
const getWoolPartyUser = async (params) => {
  const { data } = await axios.post(getWoolPartyUserUrl, params)
  return data.data
}

const myRewardUrl = '/activity/newcomer/my-reward'
const myReward = async (body = {}) => {
  const { data } = await axios.post(myRewardUrl, body)
  return data.data
}

const drawPrizeUrl = '/activity/newcomer/extraction-reward-amount'
const drawPrize = async (params) => {
  const { data } = await axios.post(drawPrizeUrl, params)
  return data.data
}

const questionUrl = '/activity/newActivityGlobalConfig/question'
const question = async (params = {}) => {
  const { data } = await axios.post(questionUrl, params)
  return data.data
}

const withdrawalUrl = '/activity/newcomer/withdrawal'
const withdrawal = async (params) => {
  const { data } = await axios.post(withdrawalUrl, params)
  return data.data
}

const registerSendBTCInfoUrl = '/activity/currentActivityInfo'
const registerSendBTCInfo = async (body = {}) => {
  const { data } = await axios.post(registerSendBTCInfoUrl, body)
  return data.data
}

const registerSendBTCUserInfoUrl = '/activity/user/currentActivityInfo'
const registerSendBTCUserInfo = async (body = {}) => {
  const { data } = await axios.post(registerSendBTCUserInfoUrl, body)
  return data.data
}

const registerSendBTCSubmitUrl = '/activity/user/audit'
const registerSendBTCSubmit = async (body = {}) => {
  const { data } = await axios.post(registerSendBTCSubmitUrl, body)
  return data.data
}

const registerSendBTCReceiveUrl = '/activity/user/receiveAward'
const registerSendBTCReceive = async (body = {}) => {
  const { data } = await axios.post(registerSendBTCReceiveUrl, body)
  return data.data
}

// 新人拉新活动
const popUpOrNotUrl = '/activity/newRegisterActivity/novice/rank/popUpOrNot'
const popUpOrNot = async (params = {}) => {
  const { data } = await axios.post(popUpOrNotUrl, params)
  return data.data
}

// 手动领取奖励
const forUserUrl = '/activity/reward/forUser'
const forUser = async (params = {}) => {
  const { data } = await axios.post(forUserUrl, params)
  return data.data
}

// 拉新活动领取奖励
const newRegisterActivitySubmitUrl = '/activity/user/newRegisterActivity/submit'
const newRegisterActivitySubmit = async (params = {}) => {
  const { data } = await axios.post(newRegisterActivitySubmitUrl, params)
  return data
}

const winningRecordUrl = '/activity/winning/record'
const winningRecord = async (params = {}) => {
  const { data } = await axios.post(winningRecordUrl, params)
  return data
}

const christmasApplyUrl = '/activity/christmas/apply'
const christmasApply = async (params = {}) => {
  const { data } = await axios.post(christmasApplyUrl, params)
  return data
}

const christmasDetailUrl = '/activity/christmas/detail'
const christmasDetail = async (params = {}) => {
  const { data } = await axios.post(christmasDetailUrl, params)
  return data
}

const TimesReceiveUrl = '/activity/christmas/timesReceive'
const timesReceive = async (params = {}) => {
  const { data } = await axios.post(TimesReceiveUrl, params)
  return data
}

const awardRecordUrl = '/activity/christmas/awardRecord'
const awardRecord = async (params = {}) => {
  const { data } = await axios.post(awardRecordUrl, params)
  return data.data
}

const christmasDrawUrl = '/activity/christmas/draw'
const christmasDraw = async (params = {}) => {
  const { data } = await axios.post(christmasDrawUrl, params)
  return data.data
}

const christmasInviteRecordUrl = '/activity/christmas/inviteRecord'
const christmasInviteRecord = async (params = {}) => {
  const { data } = await axios.post(christmasInviteRecordUrl, params)
  return data.data
}

const landingPageListUrl = '/activity/landingPage/list'
const landingPageList = async (params = {}) => {
  const { data } = await axios.post(landingPageListUrl, params)
  return data.data
}

const landingPageDetailUrl = '/activity/landingPage/detail'
const landingPageDetail = async (params = {}) => {
  const { data } = await axios.post(landingPageDetailUrl, params)
  return data.data
}

const landingPageApplyUrl = '/activity/landingPage/apply'
const landingPageApply = async (params = {}) => {
  const { data } = await axios.post(landingPageApplyUrl, params)
  return data.data
}

const landingTimesReceiveUrl = '/activity/turntable/timesReceive'
const landingTimesReceive = async (params = {}) => {
  const { data } = await axios.post(landingTimesReceiveUrl, params)
  return data.data
}

const turntableDrawUrl = '/activity/turntable/draw'
const landingTurntableDraw = async (params = {}) => {
  const { data } = await axios.post(turntableDrawUrl, params)
  return data.data
}

const langdingAwardRecordUrl = '/activity/turntable/awardRecord'
const langdingAwardRecord = async (params = {}) => {
  const { data } = await axios.post(langdingAwardRecordUrl, params)
  return data.data
}

const applyPageListUrl = '/activity/applyPage/list'
const applyPageList = async (params = {}) => {
  const { data } = await axios.post(applyPageListUrl, params)
  return data.data
}

const applyPageDetailUrl = '/activity/applyPage/detail'
const applyPageDetail = async (params = {}) => {
  const { data } = await axios.post(applyPageDetailUrl, params)
  return data.data
}

const applyPageApplyUrl = '/activity/applyPage/userApply'
const applyPageApply = async (params = {}) => {
  const { data } = await axios.post(applyPageApplyUrl, params)
  return data.data
}

const movieTicketPurchaseUrl = '/activity/movieTicket/purchase'
const movieTicketPurchase = async (params = {}) => {
  const { data } = await axios.post(movieTicketPurchaseUrl, params)
  return data.data
}

const movieTicketOrdersUrl = '/activity/movieTicket/orders'
const movieTicketOrders = async (params = {}) => {
  const { data } = await axios.post(movieTicketOrdersUrl, params)
  return data.data
}

// 世界杯活动二：活动时间
const worldCupTimeConfigUrl = '/activity/worldCup2026/time/config'
const worldCupTimeConfig = (params = {}, options = {}) =>
  useReq(worldCupTimeConfigUrl, { method: 'GET', params, auth: false }, options)

// 世界杯活动一：前台轮次列表
const worldCupRoundListUrl = '/activity/worldCup2026/round/list'
const worldCupRoundList = (params = {}, options = {}) =>
  useReq(worldCupRoundListUrl, { method: 'GET', params }, options)

// 世界杯活动一：兑换抽奖码
const worldCupLotteryExchangeUrl = '/activity/worldCup2026/lottery/exchange'
const worldCupLotteryExchange = (params = {}, options = {}) =>
  useReq(worldCupLotteryExchangeUrl, { method: 'POST', data: params, okCodes: [0, 1] }, { immediate: false, ...options })

// 世界杯活动一：中奖名单
const worldCupWinnerListUrl = '/activity/worldCup2026/winner/list'
const worldCupWinnerList = (params = {}, options = {}) =>
  useReq(worldCupWinnerListUrl, { method: 'GET', params, auth: false }, options)

// 世界杯活动一：翻倍交易对
const worldCupTradeMarketUrl = '/activity/worldCup2026/trade/market'
const worldCupTradeMarket = (params = {}, options = {}) =>
  useReq(worldCupTradeMarketUrl, { method: 'GET', params, auth: false }, options)

// 世界杯活动二：实时排行榜 / 我的排名
const worldCupRankListUrl = '/activity/worldCup2026/rank/list'
const worldCupRankList = (params = {}, options = {}) =>
  useReq(worldCupRankListUrl, { method: 'GET', params }, options)

// 世界杯活动二：奖励梯度配置
const worldCupRankPrizeConfigUrl = '/activity/worldCup2026/rank/prize/config'
const worldCupRankPrizeConfig = (params = {}, options = {}) =>
  useReq(worldCupRankPrizeConfigUrl, { method: 'GET', params, auth: false }, options)

// 世界杯活动二：竞猜赛程
const worldCupPredictionMatchListUrl = '/activity/worldCup2026/prediction/match/list'
const worldCupPredictionMatchList = (params = {}, options = {}) =>
  useReq(worldCupPredictionMatchListUrl, { method: 'GET', params }, options)

// 世界杯活动二：提交竞猜
const worldCupPredictionSubmitUrl = '/activity/worldCup2026/prediction/submit'
const worldCupPredictionSubmit = (params = {}, options = {}) =>
  useReq(worldCupPredictionSubmitUrl, { method: 'POST', data: params }, { immediate: false, ...options })

const needLoginUrl = [registerSendBTCUserInfoUrl, popUpOrNotUrl, forUserUrl, TimesReceiveUrl, christmasInviteRecordUrl, movieTicketPurchaseUrl, movieTicketOrdersUrl, worldCupPredictionSubmitUrl, worldCupLotteryExchangeUrl]

export default {
  needLoginUrl,
  myReward,
  getWoolPartyUser,
  queryHome,
  drawPrize,
  question,
  withdrawal,
  registerSendBTCInfo,
  registerSendBTCUserInfo,
  registerSendBTCSubmit,
  registerSendBTCReceive,
  popUpOrNot,
  forUser,
  newRegisterActivitySubmit,
  winningRecord,
  christmasApply,
  christmasDetail,
  timesReceive,
  awardRecord,
  christmasDraw,
  christmasInviteRecord,
  landingPageList,
  landingPageDetail,
  landingPageApply,
  landingTimesReceive,
  landingTurntableDraw,
  langdingAwardRecord,
  applyPageList,
  applyPageDetail,
  applyPageApply,
  movieTicketPurchase,
  movieTicketOrders,
  worldCupTimeConfig,
  worldCupRoundList,
  worldCupLotteryExchange,
  worldCupWinnerList,
  worldCupTradeMarket,
  worldCupRankList,
  worldCupRankPrizeConfig,
  worldCupPredictionMatchList,
  worldCupPredictionSubmit,
}
